import { apiService } from "@/_services";
import { timeParseNull2 } from "@/_core/_helpers/_helpers";

/**
 * Sends a request to simulate commodity analytics and processes the response.
 * @param {object} _this - Context variables, usually the Vue component instance.
 * @param {string} fieldName - Name of the field where the fetched data will be stored.
 * @param {string} fieldShowLoadingName - Name of the field that controls the loading state.
 */
export function postAnalyticsCommoditySimulate(
  _this,
  fieldName,
  fieldShowLoadingName
) {
  // Set loading state to true before making the request
  _this[fieldShowLoadingName] = true;
  // Define API request parameters
  let params = {
    method: "POST",
    endpoint: "analytics_commodity_simulate",
    content_type: "application/json",
    query_params: {
      format: "json", // Response format
      commodity: _this.commodityNumber, // Commodity identifier
      confidence: _this.confidence / 100, // Convert confidence percentage to decimal
      expo: JSON.stringify(_this.expoDataRaw), // Convert exposure data to JSON string
      hedge: JSON.stringify(_this.hedgeDataRaw) // Convert hedge data to JSON string
    }
  };
  // Send API request
  return apiService
    .getAll(params)
    .then(response => {
      if (!response || response.length === 0) {
        throw new Error("Received empty data response");
      }
      // Ensure response is in a proper format by parsing and deep copying
      response = JSON.parse(JSON.stringify(response));
      // Process each data entry to correctly format date fields
      response.forEach(function(d) {
        d.date = timeParseNull2(d.date);
        d.date_raw = d.date;
        d.p_date = timeParseNull2(d.p_date);
        d.hedged_date = timeParseNull2(d.hedged_date);
        d.sale_date = timeParseNull2(d.sale_date);
      });
      // Remove unnecessary row property from each entry
      response.forEach(function(d) {
        delete d.row;
      });
      // Store the processed data in the component state
      Object.assign(_this, { simulationsRaw: response });
      // Set loading state to false after successful data retrieval
      _this[fieldShowLoadingName] = false;
    })
    .catch(error => {
      // Handle errors and reset loading state
      console.error(
        "Error fetching Analytics Commodity Simulation Data:",
        error
      );
      _this[fieldShowLoadingName] = false;
    });
}
